import { RootState } from '../typedefs/store';

export const getSettings = (state: RootState) => state.settings;
export const getBrowserCapabilities = (state: RootState) => state.settings.browser;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/selectors/settings.ts